<template>
    <b-container fluid class="animated fadeIn">
        <h1>Incluir Carta CDA</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div>
                        <b-card class="primary-semi p-2">
                            <b-row v-if="filtro.cpfCnpj">
                                <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                    <b-form-group label="CPF/CNPJ:" label-for="cpfCnpj" class="text-label">
                                        <p id="cpfCnpj">{{ filtro.cpfCnpj | cpfCnpj }}</p>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="filtro.tipoCredito">
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
                                        <template v-for="tipo in filtro.tipoCredito">
                                            <p :key="tipo.id">
                                                {{ tipo.nome }}
                                            </p>
                                        </template>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                    <b-form-group label="Tipo de Carta" label-for="radio-group-tipo-carta">
                                        <b-form-radio-group id="radio-group-tipo-carta" v-model="tipoCarta"
                                            name="radio-tipo-carta">
                                            <b-form-radio value="0">Retirada</b-form-radio>
                                            <b-form-radio value="1">Anuência</b-form-radio>
                                            <b-form-radio value="2">Indevida</b-form-radio>
                                        </b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row class="justify-content-left">
                                <div class="d-flex justify-content-between mb-3">
                                    <div>
                                        <b-button variant="primary" class="fonte-branca ml-2" @click="validarEmissao()">
                                            <i class="fa fa-download"></i> Emitir Carta
                                        </b-button>
                                    </div>
                                </div>
                            </b-row>
                        </b-card>
                    </div>
                    <b-row class="mt-3">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                    <CompTabelaEmitirCartasIncluir :resultado="resultado" :fields="fields"
                                        :configTable="configTable" :selecteds="selecteds" @sortingChanged="consultarCartas"
                                        @consultarCartas="consultarCartas" />
                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-center">
                        <div class="d-flex justify-content-between mb-3">
                            <div>
                                <b-button class="mx-1" variant="secondary" @click="voltar"><i class="fa fa-reply"></i>
                                    Voltar</b-button>
                            </div>
                        </div>
                    </b-row>
                </b-col>
            </b-row>
            <b-modal ref="modalBry" size="lg" title="Modal Bry" cancel-title="Fechar">
                <Certificado :param="parametrosAssinatura" @finalizarAssinatura="processarArquivoAssinado($event)"
                    @erroAssinatura="processarErroAssinatura($event)" />
            </b-modal>
            <b-modal ref="modalJustificativa" size="lg" title="Justificativa" cancel-title="Fechar">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <b-form-textarea id="justificativa" v-model="valoresModalJustificativa.justificativa"
                            placeholder="Informe aqui a justificativa.." rows="3" max-rows="6">
                        </b-form-textarea>
                    </b-col>
                </b-row><b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <file-upload ref="upload" :multiple="false" extensions="pdf,doc,odt,docx"
                            v-model="valoresModalJustificativa.arquivos">
                            <b-button variant="primary" class="fonte-branca ml-2">
                                <i class="fa fa-upload"></i> Anexar
                            </b-button>
                        </file-upload>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col xs="12" md="12" class="mx-auto">
                        <fieldset>
                            <legend style="font-size:15px!important">Arquivos Selecionados:</legend>
                            <ul>
                                <li :key="file.name" v-for="file in valoresModalJustificativa.arquivos">{{ file.name }}</li>
                            </ul>
                        </fieldset>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <b-form-group label="Email CC:" label-for="emails" class="text-label">
                            <vue-tags-input id="emails" v-model="valoresModalJustificativa.emailAtual"
                                :tags="valoresModalJustificativa.emailsEnvio" :allow-edit-tags="true"
                                placeholder="Adicione e-mails com Enter"
                                @tags-changed="newTags => valoresModalJustificativa.emailsEnvio = newTags" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{}">
                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" class="fonte-branca ml-1" @click="confirmar()"
                            :disabled="!valoresModalJustificativa.justificativa">
                            Confirmar
                        </b-button>
                        <b-button variant="secondary" class="fonte-branca ml-1" @click="hideModalJustificativa()">
                            Cancelar
                        </b-button>
                    </div>
                </template>
            </b-modal>
            <b-modal ref="modalRetiradaIndevida" size="lg" title="Atenção!" cancel-title="Fechar">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p class="p-3">
                            Antes de emitir a Carta de <strong>RETIRADA</strong>, favor entrar em contato com o Tabelionato
                            para o qual
                            distribuído o título para a verificação do atual status do protesto, vez que o Tabelionato conta
                            com o prazo de 24h para alterar o status para “protestado” no sistema da CRA. Na hipótese de o
                            protesto já ter sido lavrado, aguardar a alteração do status no sistema da CRA para “Protestado”
                            e, após, emitir a carta de protesto <strong>INDEVIDO</strong>.
                        </p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{}">
                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" class="fonte-branca ml-1" @click="emitirCarta()">
                            Confirmar Emissão
                        </b-button>
                        <b-button variant="secondary" class="fonte-branca ml-1" @click="hideModalConfirmarEmissao()">
                            Cancelar
                        </b-button>
                    </div>
                </template>
            </b-modal>
            <b-modal ref="modalConfirmarCartaSemPagamento" size="lg" title="Atenção!" cancel-title="Fechar">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p class="p-3">
                            Atenção! O protesto ainda não conta com registro de principal pago/parcelado e/ou honorários de protesto quitados no sistema SFEPGE. 
                        </p>
                        <p class="p-3">
                            Emitir Carta de Anuência mesmo assim?
                        </p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{}">
                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" class="fonte-branca ml-1" @click="confirmarEmissao()">
                            Confirmar Emissão
                        </b-button>
                        <b-button variant="secondary" class="fonte-branca ml-1" @click="hideModalConfirmarCartaSemPagamento()">
                            Cancelar
                        </b-button>
                    </div>
                </template>
            </b-modal>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompPaginacao from './components/CompPaginacao'
import CompTabelaEmitirCartasIncluir from './components/CompTabelaEmitirCartasIncluir'
import Certificado from "assinador-bry";
import apiCentralSeguranca from '@/api/centralseguranca';
import VueTagsInput from '@johmun/vue-tags-input';

export default {
    name: 'EmitirCartasPesquisar',
    components: {
        CompPaginacao,
        CompTabelaEmitirCartasIncluir,
        Certificado,
        VueTagsInput,
    },
    data() {
        return {
            tipoCarta: 1,
            emailCra: null,
            valoresModalJustificativa: {
                justificativa: null,
                arquivos: [],
                arquivosBase64: [],
                emailAtual: '',
                emailsEnvio: []
            },
            filtro: {
                numeroDivida: null,
                cpfCnpj: null,
                tipoCredito: null
            },
            dados: {
                creditos: [],
                colunas: ['Número Dívida', 'Status Protesto', 'Comarca', 'Tabelionato', 'Prot. CRA', 'Tipo de Crédito', 'Origem', 'Valor', 'Data Inscrição', 'Nome do réu', 'CPF/CNPJ']
            },
            parametrosAssinatura: {
                config: {
                    padraoAssinatura: "1",
                    tipoAssinatura: "Attached",
                    incluiCadeia: true,
                },
                filters: {
                    CPFS: []
                },
                ambiente: process.env.VUE_APP_BRY_AMBIENTE,
                arquivo: this.listaPdfsRetorno,
                token: JSON.parse(this.$store.getters.getUser).access_token,
                consumerId: 'PGEPROAJU',
                realizarDownloadArquivoAssinado: false
            },
            configTable: {
                perPage: 30,
                sortField: 'contribuinte',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false
            },
            showColunms: [],
            selecteds: [],
            fields: [
                {
                    key: "selecionar",
                },
            ],
            resultado: [],
            listaPdfsRetorno: [],
            arquivosConvertidosFinal: [],
            cartaSemPagamento: false
        }
    },
    watch: {
        perPage() {
            this.configTable.currentPage = 1
            this.consultarCartas()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        }
    },
    methods: {
        confirmar() {
            if (!this.valoresModalJustificativa.justificativa) {
                return
            }

            if (this.valoresModalJustificativa.arquivos != null &&
                this.valoresModalJustificativa.arquivos.length > 0) {
                this.valoresModalJustificativa.arquivos.forEach(file => {
                    var arquivoConvertido;
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        arquivoConvertido = {
                            nomeArquivo: file.name,
                            base64: e.target.result
                        };
                    };
                    reader.readAsDataURL(file.file);
                    reader.onloadend = () => this.executarEmitirCarta(arquivoConvertido)
                })
            } else {
                this.executarEmitirCarta(null);
            }
        },
        confirmarEmissao() {
            this.$store.commit("setMessages", {});
			
			this.hideModalConfirmarEmissao();
            
            if (this.tipoCarta == "0") {
                this.$refs['modalRetiradaIndevida'].show();
                
            } else {
                this.emitirCarta();
            }
        },
        /**
        * Validar Emitir Cartas
        */
        validarEmissao() {

            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            var nome = ''
            if (this.tipoCarta == "0") {
                nome = "Retirada"
            } else if (this.tipoCarta == "1") {
                nome = "Anuência"
            } else {
                nome = "Indevida"
            }

            let tipoCartaSelecionada = {
                id: Number(this.tipoCarta),
                nome: nome
            };

            this.selecteds.forEach(registro => {
                registro.tipoCarta = tipoCartaSelecionada
            });

            axios.post(`${urlApi}/v1/emitirCartasLote/validarEmissaoCarta`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(response => {
                   var cartaVO = response.data;
                    
                    if (cartaVO.confirmarCartaSemPagamento) {
                    	this.cartaSemPagamento = true;
                    	this.$refs['modalConfirmarCartaSemPagamento'].show();
                    	
                    } else {
						this.cartaSemPagamento = false;
                    	this.confirmarEmissao();
                    }
                })
                .catch((error) => {
                    
                    if (error && error.message) {
                        this.$store.commit("setMessages", { message: 'Erro!', errors: [error.message] });
                        this.selecteds = []
                        return
                    }
                })
                .finally(() => {
                    this.loadingExit()
                })
        },
        /**
         * Emitir Cartas
         */
        emitirCarta() {
            this.hideModalConfirmarEmissao();
           
            if (this.showModalJustificativa()) {
                this.$refs['modalJustificativa'].show();
                
            } else {
                this.executarEmitirCarta();
            }
        },
        /**
         * Emitir Cartas
         */
        executarEmitirCarta(arquivoConvertido) {

            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            var nome = ''
            if (this.tipoCarta == "0") {
                nome = "Retirada"
            } else if (this.tipoCarta == "1") {
                nome = "Anuência"
            } else {
                nome = "Indevida"
            }

            let tipoCartaSelecionada = {
                id: Number(this.tipoCarta),
                nome: nome
            };

            this.selecteds.forEach(registro => {
                registro.tipoCarta = tipoCartaSelecionada
            });

            let justificativaEnvio = null;
            if (this.showModalJustificativa()) {
                var emailsEnvio = []
                // REMOVIDO APONTAMENTO AUTOMATICO RF006
                // this.valoresModalJustificativa.emailsEnvio.forEach(email => {
                //     emailsEnvio.push(email.text)
                // });

                justificativaEnvio = {
                    justificativa: this.valoresModalJustificativa.justificativa,
                    emailsEnvio: emailsEnvio,
                    emailAtual: this.valoresModalJustificativa.emailAtual,
                    arquivoBase64: arquivoConvertido
                };
            }

            let emitirVO = {
                justificativaEnvio: justificativaEnvio,
                listaSelecionadas: this.selecteds
            };

            this.loadingEnter();
            axios.post(`${urlApi}/v1/emitirCartasLote/emitirCarta`, emitirVO, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(response => {
                    this.listaPdfsRetorno = response.data
                    this.parametrosAssinatura.arquivo = this.listaPdfsRetorno

                    var msgsRecebidas = []

                    this.listaPdfsRetorno.forEach(retornoTemp => {
                        if (retornoTemp.listaMensagensRetorno) {
                            retornoTemp.listaMensagensRetorno.forEach(mensagem => {
                                msgsRecebidas.push(mensagem)
                            });
                        }
                    });

                    if (msgsRecebidas.length >= 1) {
                        this.$store.commit("setMessages", { message: 'Erro!', errors: [msgsRecebidas] });
                    } else {
                        this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Cartas emitidas com sucesso!'] });
                        this.$refs['modalBry'].show();
                    }
                })
                .catch((error) => {
                    if (error && (this.selecteds.length === 0)) {
                        this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro ocorreu ao emitir as cartas. Contacte o administrador do sistema.'] });
                        this.selecteds = []
                        return
                    }

                    if (error && error.message) {
                        this.$store.commit("setMessages", { message: 'Erro!', errors: [error.message] });
                        this.selecteds = []
                        return
                    }
                })
                .finally(() => {
                    this.loadingExit()
                    this.hideModalJustificativa()
                })
        },
        processarErroAssinatura(erro) {
            alert(erro)
        },
        processarArquivoAssinado(arquivosAssinadosB64) {
            //enviar arquivo servidor, realizar download.

            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadingEnter()
            axios.post(`${urlApi}/v1/assinarCartasLote/finalizarAssinatura`, arquivosAssinadosB64, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(() => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Cartas(s) assinadas(s) com sucesso!'] });
                })
                .catch((error) => {
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro de comunicação ocorreu com um sistema externo, tente novamente mais tarde.' + error] });
                    this.selecteds = []
                })
                .finally(() => {
                    this.resultado = []
                    this.selecteds = []
                    this.result
                    this.loadingExit()
                    this.$refs['modalBry'].hide();
                    this.hideModalJustificativa();
                    this.voltar();
                })

        },
        /**
        * Abre a modal BRY
        */
        show() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            axios.post(`${urlApi}/v1/assinarCartasLote/obterPdfsCartas`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(response => {
                    this.listaPdfsRetorno = response.data
                    this.parametrosAssinatura.arquivo = this.listaPdfsRetorno
                    this.$refs['modalBry'].show();
                }).finally(() => {
                    this.loadingExit()
                })
        },
        hide() {
            this.$refs['modalBry'].hide();
        },

        /**
         * Abre a modal de justificativa
         */
        showModalJustificativa() {
            if (this.tipoCarta == "0" || this.tipoCarta == "2" || this.cartaSemPagamento) {
                return true;
            } else {
                return false;
            }
        },
        hideModalJustificativa() {
            this.$refs['modalJustificativa'].hide();
        },
        hideModalConfirmarEmissao() {
            this.$refs['modalRetiradaIndevida'].hide();
            this.$refs['modalConfirmarCartaSemPagamento'].hide();
        },
        hideModalConfirmarCartaSemPagamento() {
            this.$refs['modalConfirmarCartaSemPagamento'].hide();
        },
        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                numeroDivida: null,
                cpfCnpj: null,
                credito: null
            }
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.selecteds = []
            this.consultarCartas()
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if (i == 0 || i == 2 || i == 3 || i == 4 || i == 6 || i == 7)
                return 'text-center justify-content-center'
            if (i == 7)
                return 'text-right justify-content-center'
            return 'justify-content-center'
        },

        /**
         * Volta para a dashboard
         */
        voltar() {
            this.$router.push('/emitir-cartas');
        },

        /**
         * Consultar divídas
         */
        async consultarCartas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = {
                numeroDivida: this.filtro.numeroDivida,
                cpfCnpj: this.filtro.cpfCnpj,
                tipoCredito: this.filtro.tipoCredito
            }

            let perPageStr = `&perPage=${this.configTable.perPage}`
            if (this.configTable.perPage === 'Todos') {
                perPageStr = ''
                this.configTable.currentPage = 1
                this.configTable.rows = 0
            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/emitirCartasLote/consultarIncluir?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    if (response.data.message) {
                        this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: [response.data.message] });
                    } else {
                        this.resultado = response.data.resultado
                        if (this.configTable.perPage !== 'Todos') {
                            this.configTable.rows = response.data.rows
                        }

                        this.resultado.forEach(result => {
                            result.checked = false
                            this.selecteds.forEach(selected => {
                                if (result.codCdaProtesto == selected.codCdaProtesto) {
                                    result.checked = true
                                }
                            })
                        })
                    }

                }).finally(() => {
                    this.loadingExit()
                })
        },

        /**
         * Listar os Tipos de Crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/assinarCartasLote/listarTipoCredito`)
                .then(response => {
                    this.dados.creditos = response.data
                })
        },

        dadosUsuario() {
            let dados = '';
            apiCentralSeguranca.getInformacoesCidadao((JSON.parse(this.$store.getters.getUser).access_token))
                .then(res => {
                    dados = res.data;
                    this.cpfUsuarioLogado = dados.cpf
                    this.parametrosAssinatura.filters.CPFS.push(this.cpfUsuarioLogado)
                })
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async configurarColunas() {
            this.dados.colunas.forEach((field, i) => {
                this.showColunms.push(i + 1)
                this.fields.push({
                    key: `${i + 1}`,
                    label: `${field}`,
                    sortable: true,
                    sortDirection: "desc",
                    class: this.checkClassTable(i),
                    thClass: '',
                    tdClass: '',
                    codColunaFuncionalidade: i,
                    codFuncionalidade: i
                })
            })
        },
        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
            }
        },

    },
    mounted() {
        const urlApi = process.env.VUE_APP_ROOT_API
        //valores vindos da tela de pesquisar
        this.filtro.numeroDivida = this.$route.query.numeroDivida
        this.filtro.cpfCnpj = this.$route.query.cpfCnpj
        this.filtro.tipoCredito = this.$route.query.tipoCredito

        //REMOVIDO RF006
        // axios.get(`${urlApi}/v1/emitirCartasLote/obterParametro`)
        //     .then(response => {
        //         this.emailCra = response.data.emailCra
        //         if (response.data.emailCra != undefined) {
        //             let email = {
        //                 text: this.emailCra,
        //                 tiClasses: ["ti-valid"]
        //             }
        //             this.valoresModalJustificativa.emailsEnvio.push(email)
        //         }
        //     })

        this.$store.commit("setMessages", {});

        this.dadosUsuario()

        this.configurarColunas()

        this.listarTipoCredito()

        this.consultarCartas()

    }

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
/* default styles for all the tags */
.vue-tags-input .ti-tag {
    position: relative;
    background: #20a8d8;
    color: white;
}

.fonte-branca {
    color: #FFF;
}

.fonte-branca:hover {
    color: #FFF;
}

.fonte-branca:active {
    color: #FFF !important;
}

.table-sub-item,
.table-sub-item>th,
.table-sub-item>td {
    background-color: rgb(237, 237, 238);
}

.font-red {
    color: red;
}
</style>